import api from './api';
import { CompanyProfile, CompanyProfileUpdateRequest } from '../types';

type WrappedApiResponse<T> = {
  success: boolean;
  data: T;
  message?: string;
};

const unwrapApiPayload = <T>(payload: unknown): T => {
  if (
    payload !== null &&
    typeof payload === 'object' &&
    'success' in (payload as Record<string, unknown>) &&
    'data' in (payload as Record<string, unknown>)
  ) {
    const wrapped = payload as WrappedApiResponse<T>;
    if (!wrapped.success) {
      throw new Error(wrapped.message || 'Error en la operacion');
    }
    return wrapped.data;
  }

  return payload as T;
};

export const companyProfileService = {
  async getProfile(): Promise<CompanyProfile> {
    const response = await api.get('/company/profile');
    return unwrapApiPayload<CompanyProfile>(response.data);
  },

  async updateProfile(
    payload: CompanyProfileUpdateRequest,
  ): Promise<CompanyProfile> {
    const response = await api.put('/company/profile', payload);
    return unwrapApiPayload<CompanyProfile>(response.data);
  },
};
